// extracted by mini-css-extract-plugin
export default {"main":"orderpagepersonal_main__jnzW+"};